import { render, staticRenderFns } from "./FieldType13.vue?vue&type=template&id=244e7d4b&scoped=true"
import script from "./FieldType13.vue?vue&type=script&lang=js"
export * from "./FieldType13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244e7d4b",
  null
  
)

export default component.exports